import { render, staticRenderFns } from "./ManageOverviewTabV2.vue?vue&type=template&id=d655640a&scoped=true"
import script from "./ManageOverviewTabV2.vue?vue&type=script&lang=js"
export * from "./ManageOverviewTabV2.vue?vue&type=script&lang=js"
import style0 from "./ManageOverviewTabV2.vue?vue&type=style&index=0&id=d655640a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_babel-core@7.0.0-bridge.0_@babel+core@7.27._f767d633ff263e3cf51932694db5e4d0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d655640a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/front/game-platform-web/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d655640a')) {
      api.createRecord('d655640a', component.options)
    } else {
      api.reload('d655640a', component.options)
    }
    module.hot.accept("./ManageOverviewTabV2.vue?vue&type=template&id=d655640a&scoped=true", function () {
      api.rerender('d655640a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/member/components/ManageOverviewTabV2.vue"
export default component.exports